// apps/web/src/api/services/visitors.service.ts
import { HttpClient } from '../http-client';
import {
  ApiResponse,
  Visitor,
  VisitorWithSubscription,
  CreateVisitorRequest,
  UpdateVisitorRequest,
  VisitorsListResponse,
  VisitorStats,
} from '@gym-management/shared';
import { AxiosResponse } from 'axios';

export class VisitorsService extends HttpClient {
  // ЕДИНСТВЕННЫЙ МЕТОД getVisitors с правильной сигнатурой
  async getVisitors(
    page = 1,
    limit = 10,
    search = '',
    active: boolean | null = null,
    checkedIn: boolean | null = null,
    hasSubscription: boolean | null = null
  ): Promise<VisitorsListResponse> {
    let url = `/api/visitors?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (active !== null) url += `&active=${active}`;
    if (checkedIn !== null) url += `&checked_in=${checkedIn}`;
    if (hasSubscription !== null) url += `&has_subscription=${hasSubscription}`;

    const response: AxiosResponse<ApiResponse<VisitorsListResponse>> = await this.get(url);
    if (response.data.success && response.data.data) {
      const data = response.data.data;
      if (data.totalPages === undefined && data.total !== undefined) {
        data.totalPages = Math.ceil(data.total / limit);
      }
      return data;
    }
    throw new Error(response.data.message || 'Failed to fetch visitors');
  }

  async createVisitor(data: CreateVisitorRequest): Promise<Visitor> {
    const response: AxiosResponse<ApiResponse<Visitor>> = await this.post('/api/visitors', data);
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to create visitor');
  }

  async updateVisitor(id: string, data: UpdateVisitorRequest): Promise<Visitor> {
    const response: AxiosResponse<ApiResponse<Visitor>> = await this.put(
      `/api/visitors/${id}`,
      data
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to update visitor');
  }

  async deleteVisitor(id: string): Promise<void> {
    const response: AxiosResponse<ApiResponse<void>> = await this.delete(`/api/visitors/${id}`);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete visitor');
    }
  }

  async getVisitorStats(search = ''): Promise<VisitorStats> {
    const url = `/api/visitors/stats${search ? `?search=${encodeURIComponent(search)}` : ''}`;
    const response: AxiosResponse<ApiResponse<VisitorStats>> = await this.get(url);
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to get visitor stats');
  }

  async getVisitor(id: string): Promise<VisitorWithSubscription> {
    const response: AxiosResponse<ApiResponse<VisitorWithSubscription>> = await this.get(
      `/api/visitors/${id}`
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to get visitor');
  }
}
